export var createPromise = function () {
    var resolvePromise = null;
    var promise = new Promise(function (resolve) {
        resolvePromise = resolve;
    });
    return [promise, resolvePromise];
};
var UniqIdUtil = /** @class */ (function () {
    function UniqIdUtil() {
        this._currentNumber = 0;
    }
    UniqIdUtil.prototype.get = function () {
        return String(this._currentNumber++);
    };
    return UniqIdUtil;
}());
export { UniqIdUtil };
